import { z } from "zod";
import { AGENT_TASK_TYPES, AGENT_TASK_STATUSES } from "../constants.js";
export const createAgentTaskSchema = z.object({
    agentId: z.string().uuid(),
    companyId: z.string().uuid(),
    goalId: z.string().uuid().nullable().optional(),
    announceChannelId: z.string().uuid().nullable().optional(),
    type: z.enum(AGENT_TASK_TYPES),
    title: z.string().min(1).max(500),
    description: z.string().max(5000).optional(),
    cronExpression: z.string().max(100).optional(),
    timezone: z.string().max(100).optional(),
    taskPrompt: z.string().max(10000).optional(),
});
export const updateAgentTaskSchema = z.object({
    title: z.string().min(1).max(500).optional(),
    description: z.string().max(5000).nullable().optional(),
    cronExpression: z.string().max(100).nullable().optional(),
    timezone: z.string().max(100).optional(),
    enabled: z.boolean().optional(),
    status: z.enum(AGENT_TASK_STATUSES).optional(),
    taskPrompt: z.string().max(10000).nullable().optional(),
    announceChannelId: z.string().uuid().nullable().optional(),
});
export const agentRegisterTaskSchema = z.object({
    title: z.string().min(1).max(500),
    description: z.string().max(5000).optional(),
    type: z.enum(AGENT_TASK_TYPES).default("recurring"),
    cronExpression: z.string().max(100).optional(),
    timezone: z.string().max(100).optional(),
    taskPrompt: z.string().max(10000).optional(),
    externalId: z.string().max(200).optional(),
    announceChannelId: z.string().uuid().optional(),
    channelSlug: z.string().max(100).optional(),
});
export const agentUpdateTaskSchema = z.object({
    title: z.string().min(1).max(500).optional(),
    description: z.string().max(5000).nullable().optional(),
    cronExpression: z.string().max(100).nullable().optional(),
    timezone: z.string().max(100).optional(),
    taskPrompt: z.string().max(10000).nullable().optional(),
    enabled: z.boolean().optional(),
    announceChannelId: z.string().uuid().nullable().optional(),
    channelSlug: z.string().max(100).nullable().optional(),
});
export const agentSyncTasksSchema = z.object({
    tasks: z.array(agentRegisterTaskSchema).min(1).max(100),
});
//# sourceMappingURL=agent-task.js.map